import React, { useEffect, useRef, useState } from 'react';

const Slide = ({ type, src, isActive, isNext }) => {
  const videoRef = useRef(null);
  const [imageSrc, setImageSrc] = useState(null);
  const slideRef = useRef(null);

  useEffect(() => {
    if (type === 'video') return;

    if (isNext) {
      setImageSrc(src);
      return;
    }
    // if (type === 'video' && videoRef.current) {
    //   if (isActive) {
    //     videoRef.current.play().catch(() => {});
    //   } else {
    //     videoRef.current.pause();
    //     videoRef.current.currentTime = 0;
    //   }
    // }
  }, [isActive, type]);

  const commonClasses = `absolute inset-0 transition-opacity duration-700 ${
    isActive ? "opacity-100" : "opacity-0"
  }`;

  // if (type === 'video') {
  //   return (
  //     <div className={commonClasses}>
  //       <video
  //         ref={videoRef}
  //         muted
  //         loop
  //         playsInline
  //         preload="auto"
  //         className="absolute inset-0 w-full h-full object-cover"
  //         style={{ visibility: isNext ? 'visible' : 'hidden' }}
  //       >
  //         <source src={src} type="video/mp4" />
  //       </video>
  //       <div className="absolute inset-0 bg-black/40" />
  //     </div>
  //   );
  // }

  return (
    <div
      className={commonClasses}
      style={{
        backgroundImage: isNext ? `url(${src})` : 'none',
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="absolute inset-0 bg-black/40" />
    </div>
  );
};

export default Slide;